module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318967.06593e4b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318967.pdf
// module id = 842
// module chunks = 0